import isEmpty from 'lodash/isEmpty'

const formatArticleFilters = (articleFilters) => {
  return [{ id: 0, slug: 'all', name: 'All' }, ...articleFilters.map(articleFilter => {
    return {
      id: articleFilter.id,
      slug: articleFilter.attributes.slug,
      name: articleFilter.attributes.name
    }
  })]
}

const formatContentTypes = (contentTypes) => {
  return [{ id: 0, slug: '', name: 'Home' }, ...contentTypes.map(contentType => {
    return {
      id: contentType.id,
      slug: contentType.attributes.slug,
      name: contentType.attributes.name,
      description: contentType.attributes.description
    }
  })]
}

const formatArticlesForIndex = (articles, articleContentTypes) => {
  return articles.map(article => {
    return {
      id: article.id,
      title: article.attributes.title,
      textSnippet: article.attributes.text_snippet,
      contentType: {
        id: articleContentTypes[0].id,
        name: articleContentTypes[0].attributes.name,
        description: articleContentTypes[0].attributes.description
      },
      mainImage: article.attributes.banner_image_url,
      publishedAt: new Date(article.attributes.published_at),
      slugUrl: article.attributes.slug
    }
  })
}

const formatArticlesForFilter = (articles, articleContentTypes, articleTags, articleFilters) => {
  let tag = {}
  if (!isEmpty(articleTags)) {
    tag = {
      id: articleTags[0].id,
      name: articleTags[0].attributes.name
    }
  }
  let articleFilter = {}
  if (!isEmpty(articleFilters)) {
    articleFilter = {
      id: articleFilters[0].id,
      name: articleFilters[0].attributes.name
    }
  }

  return articles.map(article => {
    let articleContentType = articleContentTypes.find(contentType => contentType.id === article.relationships.content_types.data[0].id)

    if (!articleContentType) {
      articleContentType = articleContentTypes[0]
    }

    return {
      id: article.id,
      title: article.attributes.title,
      textSnippet: article.attributes.text_snippet,
      contentType: {
        id: articleContentType.id,
        name: articleContentType.attributes.name,
        description: articleContentType.attributes.description
      },
      mainImage: article.attributes.banner_image_url,
      publishedAt: new Date(article.attributes.published_at),
      slugUrl: article.attributes.slug,
      tags: tag,
      articleFilters: articleFilter,
      mainImageAltText: article.attributes.alt_text
    }
  })
}

export {
  formatArticleFilters,
  formatContentTypes,
  formatArticlesForIndex,
  formatArticlesForFilter
}
